export default __webpack_public_path__ + "static/media/laptop7.229eb1bd.jpeg";